/* eslint-disable eqeqeq */
/* react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import './nbaScoreboards.scss';
import { httpGet, httpGetPlain } from '../../../store/externalCalls/httpCalls';
import { connect } from 'react-redux';

const NbaScoreboards = (props) => {
  const {
   
  } = props;
  const [eventVFX,setEventVFX] =useState('vfx-event');
  const [eventSCOREBOARD,setEventSCOREBOARD] =useState('scoreboard-update');
  const [defaultCam,setDefaultCam] =useState("vCR-1-1");
  const [cameraFilter,setCameraFilter] =useState("");
  const [contentId,setContentId]=useState("4");
  const [channel,setChannel] =useState('xtadium.content.'+contentId);
  // const [url,setUrl] =useState("interactableGraphic/scoreboards/nba/");
  
  const [url,setUrl] =useState("interactableGraphic/scoreNavbar/live/nba/");

  const [iframeUrl,setIframeUrl] =useState(process.env.REACT_APP_BACKEND_URL+url+contentId);

  const [miniCameraSelected,setMiniCameraSelected] =useState('vCR-1-1');
  const [mainCameraSelected,setMainCameraSelected] =useState('vCR-1-1');
  const [miniAwaypoints,setMiniAwaypoints]=useState(0);
  const [miniHomepoints,setMiniHomepoints]=useState(0);
  const [miniPeriodNumber,setMiniPeriodNumber]=useState('1st');
  const [miniPeriodText,setMiniPeriodText]=useState('QTR');
  const [websocketVFXCounter,setWebsocketVFXCounter] =useState(0);
  const [websocketSCOREBOARDCounter,setWebsocketSCOREBOARDCounter] =useState(0);
  const [mainAwaypoints,setMainAwaypoints]=useState(0);
  const [mainHomepoints,setMainHomepoints]=useState(0);
  const [mainPeriodNumber,setMainPeriodNumber]=useState('1st');
  const [mainPeriodText,setMainPeriodText]=useState('QTR');
  const [connectionStatusVFX,setConnectionStatusVFX] =useState(false);
  const [connectionStatusSCOREBOARD,setConnectionStatusSCOREBOARD] =useState(false);
  const [historicValue,setHistoricValue]=useState(process.env.REACT_APP_BACKEND_URL+"client/NBAScoreboardHistory/");
  const [getStartIngestUrl] =useState("NBAGetStartIngestAt/");
  const [historicUrl,setHistoricUrl] =useState(process.env.REACT_APP_BACKEND_URL+"client/NBAScoreboardHistory/4");
  const [errorMsg,setErrorMsg] =useState("");
  const [okMsg,setOkMsg]=useState("");
  const [VFXList,setVFXList] =useState([]);
  const [VFXFilter,setVFXFilter] =useState([]);
  const [SCOREBOARDList,setSCOREBOARDList]=useState([]);
  const [SCOREBOARDFilter,setSCOREBOARDFilter]=useState([]);
  const iframeRef = useRef();
  useEffect(() => {
    
  }, []);
  const handlerChangeCameraFilter=(e)=>{
    if(e.target.value!=""){
      let myVfxFilter=VFXList.filter((item)=>{
        return item.targetCamera.includes(e.target.value);
      });
      setVFXFilter(myVfxFilter);

      let myScoreboardFilter=SCOREBOARDList.filter((item)=>{
        return item.data[0].videoPublishId.includes(e.target.value);
      });
      setSCOREBOARDFilter(myScoreboardFilter);
      
    }else{
      setVFXFilter(null);
    }
    setCameraFilter(e.target.value);
  }
  const handlerChannelOnChange=(e)=>{
    setChannel(e.target.value);
  }
  const handlerEventVFXOnChange=(e)=>{
    setEventVFX(e.target.value);
  }
  const handlerEventSCOREBOARDOnChange=(e)=>{
    setEventSCOREBOARD(e.target.value);
  }
  const handlerHistoric=(e)=>{
    let url=historicValue+contentId+"/999999999999999";
    httpGetPlain(url).then((res)=>{
      if(res.error){
        alert(res.error);
      }else{
        res.data.forEach((el)=>{
          let keys=Object.keys(el);
          keys.forEach((el2)=>{
            let data={"data":[el[el2].message]};
            sendTestWebsocketInformation(data,"VFX");
          });
        });
      }
    }).catch(error=>{
      alert("Historic info not found for this content"+JSON.stringify(error));
    });
  }

  const handleResponse = (response) => {
  if (!response.ok) {
    return Promise.reject(response);
  }
  return response.json();
};

const handleError = async (response) => {
  if (response.code === DOMException.ABORT_ERR) {
    return Promise.reject();
  }
  const error = await response.json().then((data) => data);
  return Promise.reject(error);
};
  const getHeaders = () => {
    const header = {
      'Content-Type': 'application/json',
      'sec-fetch-site': 'cross-site',
      Accept: 'application/json',
    };
    return header;
  };
  
  const handlerOnConnectVFX=()=>{
    setVFXList([]);
    let provider="soketi";
    if(channel=="" || eventVFX=="" ){
      alert("You need to define the channel and event");
    }
    console.log("Starting connection to provider",provider," on channel",channel,"and event", eventVFX);

    let socket_key;
    
    if(provider=="soketi")
      socket_key=process.env.REACT_APP_WEBSOCKET_SOKETI_KEY;
    else
      socket_key=process.env.REACT_APP_PUSHER_KEY;

    // console.log(socket_key);
    let websocketUrl=process.env.REACT_APP_WEBSOCKET_SOKETI;
    if(provider=="soketi"){
      websocketUrl=process.env.REACT_APP_WEBSOCKET_SOKETI;
    }else if(provider=="laravel"){
      websocketUrl = process.env.REACT_APP_WEBSOCKET;
    }
    window.Pusher = Pusher;
    window.EchoVFX = new Echo({
      broadcaster: 'pusher',
      key: socket_key,
      wsHost: websocketUrl,
      disableStats: true,
      encrypted: true,
      enabledTransports: ['ws', 'wss'], // <-- only use ws and wss as valid transports
    });

    window.EchoVFX.channel(channel).listen(`.`+eventVFX, (e) => {
      
      handlerNewWebsocketVFXMessage(e);
    });

    setConnectionStatusVFX(true);
  }
  const handlerOnConnectSCOREBOARD=()=>{
    setSCOREBOARDList([]);
    let provider="soketi";
    if(channel=="" || eventSCOREBOARD=="" ){
      alert("You need to define the channel and event");
    }
    console.log("Starting connection to provider",provider," on channel",channel,"and event", eventSCOREBOARD);

    let socket_key;
    
    if(provider=="soketi")
      socket_key=process.env.REACT_APP_WEBSOCKET_SOKETI_KEY;
    else
      socket_key=process.env.REACT_APP_PUSHER_KEY;

    // console.log(socket_key);
    let websocketUrl=process.env.REACT_APP_WEBSOCKET_SOKETI;
    if(provider=="soketi"){
      websocketUrl=process.env.REACT_APP_WEBSOCKET_SOKETI;
    }else if(provider=="laravel"){
      websocketUrl = process.env.REACT_APP_WEBSOCKET;
    }
    window.Pusher = Pusher;
    window.EchoSCOREBOARD = new Echo({
      broadcaster: 'pusher',
      key: socket_key,
      wsHost: websocketUrl,
      disableStats: true,
      encrypted: true,
      enabledTransports: ['ws', 'wss'], // <-- only use ws and wss as valid transports
    });

    window.EchoSCOREBOARD.channel(channel).listen(`.`+eventSCOREBOARD, (e) => {
      handlerNewWebsocketSCOREBOARDMessage(e);
    });

    setConnectionStatusSCOREBOARD(true);
  }
  const handlerOnDisconnectVFX=()=>{
    if(connectionStatusVFX==true){
      console.log("Disconnect VFX socket");
      setConnectionStatusVFX(false);
      window.EchoVFX.disconnect();
      setWebsocketVFXCounter(0);
    }
  }
  const handlerOnDisconnectSCOREBOARD=()=>{
    if(connectionStatusSCOREBOARD==true){
      console.log("Disconnect SCOREBOARD socket");
      setConnectionStatusSCOREBOARD(false);
      window.EchoSCOREBOARD.disconnect();
      setWebsocketSCOREBOARDCounter(0);
    }
  }
  const handlerNewWebsocketVFXMessage=(msg)=>{
    setWebsocketVFXCounter((prevCount) => prevCount + 1);
    setVFXList((prevItems) => [msg,...prevItems]);
    
  }
  const handlerNewWebsocketSCOREBOARDMessage=(msg)=>{
    setWebsocketSCOREBOARDCounter((prevCount) => prevCount + 1);
    setSCOREBOARDList((prevItems) => [msg,...prevItems]);
    sendTestWebsocketInformation(msg,"SCOREBOARD");
    
  }
  
  const handlerChangeUrl=(e)=>{
    setIframeUrl(e.target.value);
  }
  const handlerChangeHistoric=(e)=>{
    setContentId(e.target.value);
    setHistoricUrl(historicValue+e.target.value);
  }
  
  const handlerCameraChange=(e,mode)=>{
    if(mode=='mini')
      setMiniCameraSelected(e.target.value);
    else
      setMainCameraSelected(e.target.value);
  }
  const handlerHomepointsChange=(e,mode)=>{
    if(mode=='mini')
      setMiniHomepoints(e.target.value);
    else
      setMainHomepoints(e.target.value);
  }
  const handlerAwaypointsChange=(e,mode)=>{
    if(mode=='mini')
      setMiniAwaypoints(e.target.value);
    else
      setMainAwaypoints(e.target.value);
  }
  const handlerPeriodNumberChange=(e,mode)=>{
    if(mode=='mini')
      setMiniPeriodNumber(e.target.value);
    else
      setMainPeriodNumber(e.target.value);
  }
  const handlerPeriodTextChange=(e,mode)=>{
    if(mode=="mini")
      setMiniPeriodNumber(e.target.value);
    else
      setMainPeriodNumber(e.target.value);
  }
  const handlerChangeContentId=(e)=>{
    setContentId(e.target.value);
    setIframeUrl(process.env.REACT_APP_BACKEND_URL+url+e.target.value);
    setChannel('xtadium.content.'+e.target.value);
  }
  const handlerLoadUrl=()=>{
    let url=getStartIngestUrl+contentId;
    httpGet(url,process.env.REACT_APP_API_ENDPOINT_CLIENT).then(data =>{
        if(data.startIngestAt){
          //ok
          setOkMsg("LiveId="+data.liveId+" StartIngestAt="+data.startIngestAt+" ("+data.date+") and the content has a "+(data.isCCR?"CCR":"normal CR"));
          setErrorMsg("");
        }else{
          console.log("ere");
          setErrorMsg(data.error);
          setOkMsg("");
          console.log("error",data.error);
        }
      })
    fetchIframeResponseCode(iframeUrl).then((r)=>{
      if(r=="ok"){
        iframeRef.current.src=iframeUrl;
        handlerOnDisconnectVFX();
        handlerOnDisconnectSCOREBOARD();
        handlerOnConnectVFX();
        handlerOnConnectSCOREBOARD();
      }
    }).catch(error=>{
      let msg="Unknown error"+ JSON.stringify(error);
      setErrorMsg(msg);
        setTimeout(()=>{
          setErrorMsg("");
        },2000);
    });
    

  }
  async function fetchIframeResponseCode(url) {
    var promise = new Promise( (resolve, reject) => {
    fetch(url, {
      method: 'GET'
    })
      .then((res)=>{
        if(res.status==200)
            resolve("ok");
        else { 
          let err="There is a bad statuscode "+res.status;
          resolve(err);
        }
      })
      .catch(error=>{
        reject(error.message);
      });
    });
    return promise;
  }
  const sendTestWebsocketInformation=(msg,mode)=>{
    // console.log(mode +"- message from websocket ====="+msg);
    var iframe =iframeRef.current;
    var iframeWindow = iframe.contentWindow;
    var message ={"function":"websocketValues","data":msg};

    iframeWindow.postMessage(message,process.env.REACT_APP_BACKEND_URL);
  }
  const handlerSendMiniScreens=()=>{
    // console.log("send miniScreens",miniCameraSelected,miniHomepoints,miniAwaypoints,miniPeriodNumber,miniPeriodText);
    var iframe =iframeRef.current;
    var iframeWindow = iframe.contentWindow;
    // iframe.postMessage({ type, message });
    // console.log("values",miniCameraSelected,miniPeriodNumber,miniPeriodText,miniHomepoints,miniAwaypoints);
    var message ={"function":"sendMiniscreenValues","data":{"videoPublishId":miniCameraSelected,"scoreboardData":{"periodNumber":miniPeriodNumber,"periodText":miniPeriodText,"homepoints":miniHomepoints,"awaypoints":miniAwaypoints}}};
    iframeWindow.postMessage(message,process.env.REACT_APP_BACKEND_URL);
    
  }
  const handlerSendMainScreen=()=>{

    // console.log("send Maincreens",mainCameraSelected,mainHomepoints,mainAwaypoints,mainPeriodNumber,mainPeriodText);
    var iframe =iframeRef.current;
    var iframeWindow = iframe.contentWindow;
    // iframe.postMessage({ type, message });
    // console.log("values",miniCameraSelected,miniPeriodNumber,miniPeriodText,miniHomepoints,miniAwaypoints);
    var message ={"function":"sendMainscreenValues","data":{"videoPublishId":mainCameraSelected,"scoreboardData":{"periodNumber":mainPeriodNumber,"periodText":mainPeriodText,"homepoints":mainHomepoints,"awaypoints":mainAwaypoints}}};
    iframeWindow.postMessage(message,process.env.REACT_APP_BACKEND_URL);
  }
  const formatTime=(milliseconds)=>{
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
  
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
  const formatDate=(timestamp)=>{
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

  }
  

  return (
    <div className="nba-scoreboards">
        <div className="element-big">
          <div className="block-title">Load Scoreboard </div>
          <div className="formUrl">
            <form>
              <div className='contentId'>
                <label htmlFor="scoreboardUrl">ContentId:</label><br/>
                <input type="text" id="contentId" name="contentId" value={contentId} onChange={handlerChangeContentId} />
              </div>
              <div className="url">
                <label htmlFor="scoreboardUrl">Url:</label><br/>
                <input type="text" id="scoreboardUrl" name="scoreboardUrl" value={iframeUrl} placeholder="URL/league/contentId/cameraSelected" onChange={handlerChangeUrl} />
              </div>
              <div className="channelPosition">
                  <label htmlFor="channel">Channel:</label><br/>
                  <input type="text" id="channel" name="channel" value={channel} onChange={handlerChannelOnChange} />
              </div>
              <div className="eventPosition">
                  <label htmlFor="away">Event VFX:</label><br/>
                  <input type="text" id="event" name="event" value={eventVFX} onChange={handlerEventVFXOnChange}/>
              </div>
              {connectionStatusVFX===false &&   
                <div className="eventButton">
                  <button className="websocketConnect" type="button" onClick={handlerOnConnectVFX}>Connect VFX</button>
                </div>
              }
              {connectionStatusVFX===true && 
                <div className="eventButton">
                  <button className="buttonOff" type="button" onClick={handlerOnDisconnectVFX}>Disconnect VFX</button>
                </div>
              }
              <div className="eventPosition">
                  <label htmlFor="away">Event Scoreboard:</label><br/>
                  <input type="text" id="event" name="event" value={eventSCOREBOARD} onChange={handlerEventSCOREBOARDOnChange}/>
              </div>
              {connectionStatusSCOREBOARD===false &&            
                <div className="eventButton">
                  <button className="websocketConnect" type="button" onClick={handlerOnConnectSCOREBOARD}>Connect SCOREBOARD</button>
                </div>
              }
              {connectionStatusSCOREBOARD===true && 
                <div className="eventButton">
                  <button className="buttonOff" type="button" onClick={handlerOnDisconnectSCOREBOARD}>Disconnect SCOREBOARD</button>
                </div>
              }
               <div className="historicPosition">
                  <label htmlFor="historic">Historic:</label><br/>
                  <button className="websocketConnect" type="button" onClick={handlerHistoric}>Load Historic</button>
              </div>
              <button className="loadUrl" type="button" onClick={(e)=>{handlerLoadUrl()}}>LOAD SCOREBOARD</button>
              <div className="errorText">{errorMsg}</div>
              <div className="okText">{okMsg}</div>
            </form>
          </div>
        </div>
        <div className="parent">
          <div className="element hidden">
            <div className="block-title">Miniscreens </div>
            <div className="form">
                <form>
                    <div className="videoPublishIdPosition">
                        <label htmlFor="videoPublishId">Video Publish ID:</label><br/>
                        <select id="videoPublishId" name="videoPublishId" value={miniCameraSelected} onChange={(e)=>{handlerCameraChange(e,'mini')}}>
                            <option value="vCR-1-1">vCR-1-1</option>
                            <option value="vCCR-1-1">vCCR-1-1</option>
                            <option value="vCR-1-2">vCR-1-2</option>
                            <option value="vCR-1-3">vCR-1-3</option>
                            <option value="vCR-1-4">vCR-1-4</option>
                            <option value="vCR-1-5">vCR-1-5</option>
                            <option value="vCR-1-6">vCR-1-6</option>
                            <option value="vCR-1-7">vCR-1-7</option>
                            <option value="vCR-1-8">vCR-1-8</option>
                        </select>
                    </div>
                    <div>
                        <label htmlFor="home">Home Points:</label><br/>
                        <input type="number" id="homepoints" name="homepoints" value={miniHomepoints} onChange={(e)=>{handlerHomepointsChange(e,'mini')}} />
                    </div>
                    <div>
                        <label htmlFor="away">Away Points:</label><br/>
                        <input type="number" id="awaypoints" name="awaypoints" value={miniAwaypoints} onChange={(e)=>{handlerAwaypointsChange(e,'mini')}}/>
                    </div>
                    <div>
                        <label htmlFor="periodNumber">Period Number:</label><br/>
                        <select id="periodNumber" name="periodNumber" value={miniPeriodNumber} onChange={(e)=>{handlerPeriodNumberChange(e,'mini')}}>
                            <option value="1st">1st</option>
                            <option value="2nd">2nd</option>
                            <option value="3rd">3rd</option>
                            <option value="4th">4th</option>
                        </select>
                    </div>
                    <div>
                        <label htmlFor="periodText">Period Text:</label><br/>
                        <select id="periodText" name="periodText" value={miniPeriodText} onChange={(e)=>{handlerPeriodTextChange(e,'mini')}}>
                            <option value="QTR">QTR</option>
                            <option value="OT">OT</option>
                        </select>
                    </div>
            
                    <button className="sendMiniscreens" type="button" onClick={handlerSendMiniScreens}>Send values to iframe</button>
                </form>
            </div>
        </div>
        <div className="element hidden">
            <div className="block-title">Mainscreen </div>
            <div className="form">
                <form>
                    <div className="videoPublishIdPosition">
                        <label htmlFor="videoPublishIdMain">Video Publish ID:</label><br/>
                        <select id="videoPublishIdMain" name="videoPublishIdMain" value={mainCameraSelected}  onChange={(e)=>handlerCameraChange(e,'main')}>
                            <option value="vCR-1-1">vCR-1-1</option>
                            <option value="vCCR-1-1">vCCR-1-1</option>
                            <option value="vCR-1-2">vCR-1-2</option>
                            <option value="vCR-1-3">vCR-1-3</option>
                            <option value="vCR-1-4">vCR-1-4</option>
                            <option value="vCR-1-5">vCR-1-5</option>
                            <option value="vCR-1-6">vCR-1-6</option>
                            <option value="vCR-1-7">vCR-1-7</option>
                            <option value="vCR-1-8">vCR-1-8</option>
                        </select>
                    </div>
                    <div>
                        <label htmlFor="homeMain">Home Points:</label><br/>
                        <input type="number" id="homepointsMain" name="homepointsMain" value={mainHomepoints} onChange={(e)=>{handlerHomepointsChange(e,'main')}}/>
                    </div>
                    <div>
                        <label htmlFor="away">Away Points:</label><br/>
                        <input type="number" id="awaypointsMain" name="awaypointsMain" value={mainAwaypoints} onChange={(e)=>{handlerAwaypointsChange(e,'main')}} />
                    </div>
                    <div>
                        <label htmlFor="periodNumberMain">Period Number:</label><br/>
                        <select id="periodNumberMain" name="periodNumberMain" value={mainPeriodNumber} onChange={(e)=>{handlerPeriodNumberChange(e,'main')}}>
                            <option value="1st">1st</option>
                            <option value="2nd">2nd</option>
                            <option value="3rd">3rd</option>
                            <option value="4th">4th</option>
                        </select>
                    </div>
                    <div>
                        <label htmlFor="periodTextMain">Period Text:</label><br/>
                        <select id="periodTextMain" name="periodTextMain" value={mainPeriodText} onChange={(e)=>{handlerPeriodTextChange(e,'main')}}>
                            <option value="QTR">QTR</option>
                            <option value="OT">OT</option>
                        </select>
                    </div>
            
                    <button className="sendMainscreen" type="button" onClick={handlerSendMainScreen}>Send values to iframe</button>
                </form>
            </div>
        </div>
          <div className="elemen">
        </div>
    </div>
    <div className='blockData'>
        <div className="inline middle">
          <iframe ref={iframeRef} id="myIframe"  width="2550" height="3000"></iframe>
        </div>
        <div className="inline">
        <div className="element-big">
              <div className="list-filter">
                  <div className="title-websockets">FILTER BY CAMERA ID</div>
                  <div className="filter">
                    <label className="label-filter" htmlFor="camera">Camera:</label><br/>
                    <input type="text" id="cameraScore" name="cameraScore" value={cameraFilter} onChange={handlerChangeCameraFilter} />
                  </div>
              </div>
          </div>
          <div className="element-big">
              <div className="list">
                  <div className="title-websockets">VFX MESSAGES FROM WEBSOCKET</div>
                  <div id="vfxMessages" className="messagesTitle">
                    <div className='listElem'><div className='listColumn'>CameraId</div><div className='listColumn'>Event</div><div className='listColumn'>Effect</div><div className='listColumn'>Playback</div><div className='listColumn'>Extra</div><div className='listColumn listColumn--date'>Date</div></div>
                  </div>
                  <div id="vfxMessages" className="messages">
                    {cameraFilter=="" && VFXList.map((element,index)=>{
                      let extraInfo="";
                      if(element.eventIdentifier=="endgame"){
                        extraInfo=element.extraInfo.winner.team;
                      }else if(element.eventIdentifier=="pointstreak"){
                        extraInfo=element.extraInfo.team+"-"+element.extraInfo.number;
                      }else if(element.eventIdentifier=="threepointmade"|| element.eventIdentifier=="twopointmade" || element.eventIdentifier=="freethrowmade" || element.eventIdentifier=="teamtimeout" ||element.eventIdentifier=="crunchtime"){
                        if(element && element.extraInfo)
                          extraInfo=element.extraInfo.awaypoints+"-"+element.extraInfo.homepoints;
                      }
                      return <div key={index} className="listElem"><div className='listColumn'>{element.targetCamera}</div><div className='listColumn'>{element.eventIdentifier}</div><div className='listColumn'>{element.effectIdentifier}</div><div className='listColumn'>{formatTime(element.realTimeData.millisecondsFromStart)}</div><div className='listColumn'>{extraInfo}</div><div className='listColumn listColumn--date'>{formatDate(element.realTimeData.realEpoch)}</div></div>;
                    })}
                    {cameraFilter!="" && VFXFilter.map((element,index)=>{
                      let extraInfo="";
                      if(element.eventIdentifier=="endgame"){
                        extraInfo=element.extraInfo.winner.team;
                      }else if(element.eventIdentifier=="pointstreak"){
                        extraInfo=element.extraInfo.team+"-"+element.extraInfo.number;
                       }else if(element.eventIdentifier=="threepointmade"||element.eventIdentifier=="twopointmade" || element.eventIdentifier=="freethrowmade"){
                        extraInfo=element.extraInfo.awaypoints+"-"+element.extraInfo.homepoints;
                      }
                      return <div key={index} className="listElem"><div className='listColumn'>{element.targetCamera}</div><div className='listColumn'>{element.eventIdentifier}</div><div className='listColumn'>{element.effectIdentifier}</div><div className='listColumn'>{formatTime(element.realTimeData.millisecondsFromStart)}</div><div className='listColumn'>{extraInfo}</div><div className='listColumn listColumn--date'>{formatDate(element.realTimeData.realEpoch)}</div></div>;
                    })}
                  </div>
              </div>
          </div>
          <div className="element-big">
              <div className="list">
                  <div className="title-websockets">SCOREBOARD MESSAGES FROM WEBSOKETS</div>
                  <div id="vfxMessages" className="messagesTitle">
                    <div className='listElem'><div className='listColumn'>CameraId</div><div className='listColumn'>Scoreboard</div><div className='listColumn'>Playback</div><div className='listColumn listColumn--date'>Date</div></div>
                  </div>
                  <div id="scoreboardMessages" className="messages">
                    {cameraFilter=="" && SCOREBOARDList.map((element,index)=>{
                        return <div key={index} className="listElem"><div className='listColumn'>{element.data[0].videoPublishId}</div><div className='listColumn'>{element.data[0].scoreboardData.awaypoints}-{element.data[0].scoreboardData.homepoints}</div><div className='listColumn'>{formatTime(element.data[0].realTimeData.millisecondsFromStart)}</div><div className='listColumn listColumn--date'>{formatDate(element.data[0].realTimeData.realEpoch)}</div></div>;
                      })}
                      {cameraFilter!="" && SCOREBOARDFilter.map((element,index)=>{
                        return <div key={index} className="listElem"><div className='listColumn'>{element.data[0].videoPublishId}</div><div className='listColumn'>{element.data[0].scoreboardData.awaypoints}-{element.data[0].scoreboardData.homepoints}</div><div className='listColumn'>{formatTime(element.data[0].realTimeData.millisecondsFromStart)}</div><div className='listColumn listColumn--date'>{formatDate(element.data[0].realTimeData.realEpoch)}</div></div>;
                      })}
                  </div>
              </div>
          </div>
        </div>
    </div>
    </div>
  )
    
};


export default NbaScoreboards;
